(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-page"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {

    // --- Accordion: animate both opening and closing ---
    document.querySelectorAll('.faq-page__accordion').forEach(function(accordion) {
      accordion.querySelectorAll('details.faq-page__item').forEach(function(detail) {
        var summary = detail.querySelector('.faq-page__question');
        var answer = detail.querySelector('.faq-page__answer');
        var animation = null;
        var answerAnimation = null;
        var isClosing = false;
        var isOpening = false;
        var duration = 620;
        var easing = 'cubic-bezier(0.16, 1, 0.3, 1)';

        if (!summary) return;

        function clearAnimation() {
          if (animation) {
            animation.cancel();
            animation = null;
          }

          if (answerAnimation) {
            answerAnimation.cancel();
            answerAnimation = null;
          }
        }

        function finish(open) {
          detail.open = open;
          isClosing = false;
          isOpening = false;
          animation = null;

          if (answerAnimation) {
            answerAnimation.cancel();
            answerAnimation = null;
          }

          detail.style.height = '';
          detail.style.overflow = '';
        }

        function expand() {
          var startHeight = detail.getBoundingClientRect().height;

          clearAnimation();
          detail.open = true;
          detail.style.height = startHeight + 'px';
          detail.style.overflow = 'hidden';
          isOpening = true;
          isClosing = false;

          animation = detail.animate(
            {
              height: [startHeight + 'px', detail.scrollHeight + 'px']
            },
            { duration: duration, easing: easing }
          );

          if (answer) {
            answerAnimation = answer.animate(
              [
                { opacity: 0, transform: 'translateY(-8px)' },
                { opacity: 1, transform: 'translateY(0)' }
              ],
              {
                duration: 460,
                delay: 70,
                easing: easing,
                fill: 'both'
              }
            );
          }

          animation.onfinish = function() { finish(true); };
          animation.oncancel = function() { isOpening = false; };
        }

        function collapse() {
          var startHeight = detail.getBoundingClientRect().height;
          var endHeight = summary.getBoundingClientRect().height;

          clearAnimation();
          detail.style.height = startHeight + 'px';
          detail.style.overflow = 'hidden';
          isClosing = true;
          isOpening = false;

          animation = detail.animate(
            {
              height: [startHeight + 'px', endHeight + 'px']
            },
            { duration: 500, easing: easing }
          );

          if (answer) {
            answerAnimation = answer.animate(
              [
                { opacity: 1, transform: 'translateY(0)' },
                { opacity: 0, transform: 'translateY(-6px)' }
              ],
              {
                duration: 260,
                easing: 'ease-out',
                fill: 'both'
              }
            );
          }

          animation.onfinish = function() { finish(false); };
          animation.oncancel = function() { isClosing = false; };
        }

        detail._faqCollapse = collapse;

        summary.addEventListener('pointerup', function(event) {
          if (event.pointerType === 'touch') {
            window.requestAnimationFrame(function() {
              summary.blur();
            });
          }
        });

        summary.addEventListener('click', function(event) {
          event.preventDefault();

          if (
            window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
            typeof detail.animate !== 'function'
          ) {
            var willOpen = !detail.open;

            if (willOpen) {
              accordion.querySelectorAll('details.faq-page__item[open]').forEach(function(other) {
                if (other !== detail) other.open = false;
              });
            }

            detail.open = willOpen;
            return;
          }

          if (!detail.open || isClosing) {
            accordion.querySelectorAll('details.faq-page__item[open]').forEach(function(other) {
              if (other !== detail && typeof other._faqCollapse === 'function') {
                other._faqCollapse();
              }
            });
            expand();
          } else if (detail.open || isOpening) {
            collapse();
          }
        });
      });
    });

    // --- Nav: active state on scroll ---
    var nav = document.querySelector('.faq-page__nav');
    if (!nav) return;

    var links = nav.querySelectorAll('.faq-page__nav-link');
    var navSections = [];

    links.forEach(function(link) {
      var id = link.getAttribute('href').replace('#', '');
      var el = document.getElementById(id);
      if (el) navSections.push({ el: el, link: link });
    });

    if (!navSections.length) return;

    function updateActive() {
      var scrollY = window.scrollY + 120;
      var current = navSections[0];

      for (var i = 0; i < navSections.length; i++) {
        if (navSections[i].el.offsetTop <= scrollY) {
          current = navSections[i];
        }
      }

      links.forEach(function(l) { l.classList.remove('is-active'); });
      current.link.classList.add('is-active');
    }

    window.addEventListener('scroll', updateActive, { passive: true });
    updateActive();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
